import { connect } from "vuex-connect";
import { ComicMetaForm } from "../../../components";

export default connect({
  stateToProps: {
    publicationType: state => state.uploadContents.publicationType,
    secretWord: state => state.uploadContents.secretWord,
    isCommentEnabled: state => state.uploadContents.isCommentEnabled,
    isSensitive: state => state.uploadContents.isSensitive,
    isEnabledCircleMs: state => state.uploadContents.isEnabledCircleMs
  },
  mutationsToProps: {
    updatePublicationType: (commit, value) =>
      commit("uploadContents/updatePublicationType", value),
    updateSecretWord: (commit, value) =>
      commit("uploadContents/updateSecretWord", value),
    updateIsCommentEnabled: (commit, value) =>
      commit("uploadContents/updateIsCommentEnabled", value),
    updateIsSensitive: (commit, value) =>
      commit("uploadContents/updateIsSensitive", value),
    updateIsEnabledCircleMs: (commit, value) =>
      commit("uploadContents/updateIsEnabledCircleMs", value)
  }
})(ComicMetaForm.name, ComicMetaForm);
